import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PharmacyService, AuthenticationService } from '../../services';
import { Observable } from 'rxjs';
import { User } from '../../models';
import { first } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-upload-prescription',
  templateUrl: './upload-prescription.component.html',
  styleUrls: ['./upload-prescription.component.scss']
})

export class uploadPrescriptionComponent implements OnInit {
  isLoggedIn: Observable<boolean>;
  previewUrl: string | ArrayBuffer | null = null;
  selectedFiles: File[] = [];
  user: User;

  constructor( 
    public router: Router,
    private authenticationService: AuthenticationService,
    private pharmacyService: PharmacyService
   ) {}

  ngOnInit(): void {}

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.selectedFiles = Array.from(input.files); 
      const reader = new FileReader();
      reader.onload = () => {
        this.previewUrl = reader.result;
      };
      reader.readAsDataURL(input.files[0]); 
    }
  }

  openPrescriptionForm() {
    Swal.fire({
      title: 'Upload Prescription',
      html: `
        <input id="firstName" class="swal2-input mb-2" placeholder="First Name"/>
        <input id="lastName" class="swal2-input mb-2" placeholder="Last Name"/>
        <input id="email" class="swal2-input mb-2" placeholder="email@email.com"/>
        <input id="telephone" class="swal2-input mb-2" placeholder="256782123456"/>
        <input id="address" class="swal2-input mb-2" placeholder="Bugolobi, Kampala"/>
        <label for="prescriptionFile" class="p-3">Select prescription Files (You can select multiple files)</label>
        <input type="file" id="prescriptionFile" class="p-1" multiple />
      `,
      didOpen: () => {
        this.authenticationService.isLoggedIn().subscribe(isUser => {
          if (isUser) {
            this.user = this.authenticationService.currentUser()['user'];
            (document.getElementById('firstName') as HTMLInputElement).value = this.user.firstname || '';
            (document.getElementById('lastName') as HTMLInputElement).value = this.user.lastname || '';
            (document.getElementById('email') as HTMLInputElement).value = this.user.email || '';
            (document.getElementById('telephone') as HTMLInputElement).value = this.user.telephone || '';
          }
        });
      },
      customClass: {
        popup: 'custom-swal-popup'
      },
      confirmButtonText: 'Send',
      confirmButtonColor: '#00ACB1',
      showCancelButton: true,
      cancelButtonColor: '#f37b7b',
      preConfirm: () => {
        const firstName = (document.getElementById('firstName') as HTMLInputElement).value;
        const lastName = (document.getElementById('lastName') as HTMLInputElement).value;
        const email = (document.getElementById('email') as HTMLInputElement).value;
        const telephone = (document.getElementById('telephone') as HTMLInputElement).value;
        const address = (document.getElementById('address') as HTMLInputElement).value;
        const prescriptionFile = document.getElementById('prescriptionFile') as HTMLInputElement;
        if (!firstName || !lastName || !email || !telephone || !address || !prescriptionFile.files?.[0]) {
          Swal.showValidationMessage('Please fill in all fields and select a file');
          return;
        }
        return {
          firstName, 
          lastName, 
          email, 
          telephone, 
          address, 
          files: Array.from(prescriptionFile.files || [])
        };
      }
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        const formData = new FormData();
        formData.append('firstname', result.value.firstName);
        formData.append('lastname', result.value.lastName);
        formData.append('email', result.value.email);
        formData.append('telephone', result.value.telephone);
        formData.append('address', result.value.address);
        formData.append('subject', 'Prescription Submission');
        formData.append('message', `${result.value.firstName} ${result.value.lastName} has sent a prescription`);
        result.value.files.forEach((file: File) => {
          formData.append('attachments[]', file);
        });
        this.pharmacyService.uploadPrescription(formData)
          .subscribe(
            data => {
              Swal.fire({
                title: '',
                text: 'Prescription sent successfully!',
                icon: 'success',
                confirmButtonColor: 'var(--thm-base)',
              })
            },
            error => {
             Swal.fire('Error', 'Failed to send prescription.', 'error');
            }
        );
      }
    });
  }

}
